import React, { useState } from 'react';
import Image from 'next/image';
import Hotkeys from 'react-hot-keys';
import { Button, Grid, Typography } from '@material-ui/core';
import SVGPressEnter from '@assets/SVGPressEnter';
import SVGNormalNext from '@assets/SVGNormalNext';
import { StepsProps } from '@components/VideoScriptGenerator/types';
import Modal from '@components/VideoScriptGenerator/Modal';
import useStyles from './styles';
import GenerateVideoScriptModal from './components/GenerateVideoScriptModal';

const LetsGetStarted = ({ next }: StepsProps) => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const videoUrl =
    'https://stream.mux.com/o7YRlUbWwbhT00AHI56bYaJmq1VvRB5jO/high.mp4';

  return (
    <Grid
      container
      className={classes.container}
      direction="column"
      justify="center"
      alignItems="center"
    >
      <Image
        src="/assets/letsGetStartedScriptGenerator.png"
        className={classes.img}
        onClick={() => setModalOpen(true)}
        alt="let's get started"
        width="200"
        height="120"
      />
      <Typography className={classes.title} variant="h1">
        AI Video Script Generator
      </Typography>
      <Typography className={classes.description}>
        Sending video messages in sales emails increases 
        engagement and replies up to 300%... But you've gotta know what to say! 
        Use Sendspark's AI Video Script Generator to spark ideas for sales prospecting, 
        follow ups, and more. It's free!
      </Typography>
      <Hotkeys key="next" keyName="enter" onKeyUp={() => {next()}}>
        <Button
          className={classes.button}
          size="large"
          variant="contained"
          color="primary"
          onClick={() => next()}
        >
          Let's Get Started <SVGNormalNext />
        </Button>
      </Hotkeys>
      <SVGPressEnter />
      <Modal
        simple
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        className={classes.watchVideoModal}
      >
        <GenerateVideoScriptModal watchVideoURL={videoUrl} />
      </Modal>
    </Grid>
  );
};

export default LetsGetStarted;
